export default __webpack_public_path__ + "static/media/create-key-first-card-image.b93f827d.png";